import firebase from "firebase/app";
import "firebase/firestore"
import "firebase/functions"

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB1zj01k9DsvEfquOVdqZ4u-Z1OY6vyTIk",
    authDomain: "christiansciencetalksapp.firebaseapp.com",
    projectId: "christiansciencetalksapp",
    storageBucket: "christiansciencetalksapp.appspot.com",
    messagingSenderId: "621870499984",
    appId: "1:621870499984:web:25525a30415e9e6a387015",
    measurementId: "G-9SG3YYFS50",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export default firebase;
